module.exports = __webpack_public_path__ + "img/result-detail-invest-inright03.1528e123.svg";